export default __webpack_public_path__ + "static/media/ProductsList_PC_img5_Cn.d24ae60b.webp";